// IOS 兼容问题处理
const comDate = date => date.replace(/-/g, '/');
/**
 * @description: 转换时间格式
 * @param {date} 需要转换的时间
 * @param {String} 转换成的时间格式，默认'yyyy-mm-dd'
 * @return {String} 符合转换要求格式的时间
 * @author YMM
 */
function formatDate(date, fmt = 'yyyy-MM-dd') {
  if (!date) return date;
  try {
    let d = date instanceof Object ? date : typeof date === 'number' ? new Date(date) : new Date(comDate(date));
    const q = 3; // 季度
    let o = {
      'M+': d.getMonth() + 1, //月份
      'd+': d.getDate(), //日
      'h+': d.getHours(), //小时
      'm+': d.getMinutes(), //分
      's+': d.getSeconds(), //秒
      'q+': Math.floor((d.getMonth() + q) / q), //季度
      S: d.getMilliseconds() //毫秒
    };
    const yearNum = 4;
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(yearNum - RegExp.$1.length));
    for (let k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt.includes('aN') ? date : fmt;
  } catch (error) {
    return date;
  }
}
function dateParseTime(date) {
  if (!date) return date;
  if (typeof date === 'number') return date;
  if (typeof date === 'string') return Date.parse(new Date(comDate(date)));
  return Date.parse(date);
}

/**
 * @description: 创建时间列表
 * @param {date} strat 开始时间
 * @param {date} end 结束时间
 * @param {date} minute 时间间隔
 * @return {Array} 符合时间间隔的数组
 */
function createTimeList(start, end, minute) {
  let date = formatDate(new Date());
  let seconds = minute * 60,
    startSecond = dateParseTime(date + ' ' + start),
    endSecond = dateParseTime(date + ' ' + end),
    newArr = [],
    pre = 0,
    last = 0;
  let len = (endSecond - startSecond) / seconds / 1000;
  for (let i = 0; i <= len; i++) {
    pre = i * seconds * 1000 + startSecond;
    let res = formatDate(new Date(pre), 'hh:mm');
    newArr.push(res);
  }
  return newArr;
}

/**
 * @description: 获取当前日期的上一个月
 * @param {date} 当前日期
 * @return {date} 上个月日期'2020-11-23'
 */
function getPreMonth(rawData) {
  let date = formatDate(rawData);
  var arr = date.split('-');
  var year = arr[0]; //获取当前日期的年份
  var month = arr[1]; //获取当前日期的月份
  var day = arr[2]; //获取当前日期的日
  var days = new Date(year, month, 0);
  days = days.getDate(); //获取当前日期中月的天数
  var year2 = year;
  var month2 = parseInt(month) - 1;
  if (month2 == 0) {
    year2 = parseInt(year2) - 1;
    month2 = 12;
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }
  var t2 = year2 + '-' + month2 + '-' + day2;
  return t2;
}

/**
 * @description: 获取当前日期的前一天
 * @param {date} 当前日期
 * @return {date} 符合时间间隔的数组
 */
function getYesterday(date) {
  date.setDate(date.getDate() - 1);
  return formatDate(date);
}


/**
 * @description: 获取指定时间加多少分钟后的时间
 * @param time 开始时间
 * @return now 符合间隔分钟的时间
 * @author YMM
 */
 function getEndMinutes(time, t) {
  let timeArr = time.split(':');
  let h = parseInt(timeArr[0]);
  let m = parseInt(timeArr[1]);
  var date = new Date(1900, 1, 1, h, m);
  date.setMinutes(date.getMinutes() + t);
  let hour = date.getHours();
  let minutes = date.getMinutes();
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  var now = hour + ':' + minutes;
  return now;
}


/**
 * @description: 获取前几个月的具体日期
 * @param {date} 需要往前推的日期
 * @param {num} 需要往前几个月份
 * @return {date} 上个月日期'2020-11-23'
 */
function getPreMonthDay(date, monthNum) {
  let dateArr = date.split('-');
  let year = dateArr[0]; //获取当前日期的年份
  let month = dateArr[1]; //获取当前日期的月份
  let day = dateArr[2]; //获取当前日期的日
  let days = new Date(year, month, 0);
  days = days.getDate(); //获取当前日期中月的天数
  let year2 = year;
  let month2 = parseInt(month) - monthNum;
  if (month2 <= 0) {
    year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : Math.abs(parseInt(month2 / 12)) + 1);
    month2 = 12 - (Math.abs(month2) % 12);
  }
  let day2 = day;
  let days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }
  let t2 = year2 + '-' + month2 + '-' + day2;
  return t2;
}

function getAssignDay(dateStr, day) {
  //获取指定日期
  let date = new Date(dateStr);
  let rawDate = date.setDate(date.getDate() + day);
  return formatDate(rawDate);
};


function getWeekDay(date){
  //根据日期获取星期
  let dt=new Date(date.split('-')[0], date.split('-')[1]-1,date = date.split('-')[2]);
  let weekDay=['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return weekDay[dt.getDay()];
};


export default {
  formatDate,
  createTimeList,
  getPreMonth,
  getYesterday,
  getPreMonthDay,
  getAssignDay,
  getWeekDay,
  dateParseTime,
  getEndMinutes
};



// WEBPACK FOOTER //
// ./src/utils/timeTools.js